<template>
  <div class="thanks">
    <h1>Done!</h1>

    <div class="row row--separator row--separatorTop">
      <div class="row__full">
        <p>Thank you for registering!</p>
        <p>You can now sign in to start using Statzon.</p>
      </div>
    </div>

    <div class="row row--separator">
      <div class="row__full">
        <FormSubmit
          icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M13 18v-4h-7v-4h7v-4l6 6-6 6zm-1-16c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12z"/></svg>'
          @click="submit()"
        >
          Sign in to application
        </FormSubmit>
      </div>
    </div>

    <div class="row row--separator">
      <div class="row__full">
        <p class="row__notice">
          ... or sign in to <span class="link" @click="goToAI()">Statzon AI</span> instead.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import FormSubmit from '@/components/form/Submit.vue'

export default {
  components: {
    FormSubmit
  },
  methods: {
    async submit () {
      this.$emit('loggingIn')
    },
    goToAI () {
      window.location = 'https://ai.statzon.com'
    }
  },
  created () {
    this.$store.dispatch('app/setVerificationHash', false)
    this.$store.dispatch('app/setRegistrationEmail', false)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

h1, h2 {
  @include font('header--xl', $white, 0.9);
  width: 90%;
  margin: 0 auto;
  text-align: center;
  text-transform: uppercase;

  @media screen and (min-width: $breakpointLg) {
    @include font('header--xxl', $white, 0.9);
    margin: 0 auto;
  }
}

p {
  @include font('content--md', $white);

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $white);
  }
}

</style>
